// removed by extract-text-webpack-plugin
module.exports = {"Label":"PaymentType__Label__3voRG","PaymentType":"PaymentType__PaymentType__3TZrD","Inline":"PaymentType__Inline__juxSA","InputElement":"PaymentType__InputElement__1Hrer","Invalid":"PaymentType__Invalid__1EyM-","PayAmounts":"PaymentType__PayAmounts__2PQWy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/PaymentType/PaymentType.css
// module id = 200
// module chunks = 1